"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomViewStore_1 = require("@/room/room_view/roomViewStore");
const react_i18next_1 = require("react-i18next");
const material_ui_confirm_1 = require("material-ui-confirm");
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const styled_1 = __importDefault(require("@emotion/styled"));
exports.default = (0, styled_1.default)((_a) => {
    var { commentId, defaultValue, secret, onCancel } = _a, props = __rest(_a, ["commentId", "defaultValue", "secret", "onCancel"]);
    const [isSecret, setIsSecret] = (0, react_1.useState)(secret);
    const isNewComment = commentId.includes('new');
    const emptyTextArea = () => {
        const editor = document.getElementById(commentId);
        if (editor === null || editor === void 0 ? void 0 : editor.value)
            editor.value = '';
        const counter = document.getElementById(`counter_${commentId}`);
        if (counter)
            counter.innerHTML = '0<span>&#160;/500</span>';
    };
    const isLoggedIn = (0, react_redux_1.useSelector)((state) => state.whoAmI.is_logged_in);
    const userId = (0, react_redux_1.useSelector)((state) => state.whoAmI.id);
    const leaderId = (0, react_redux_1.useSelector)((state) => state.roomData.leader);
    const isLeader = userId === leaderId;
    const dispatch = (0, react_redux_1.useDispatch)();
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const updateAction = (commentData) => {
        dispatch((0, roomViewStore_1.updateComment)({ commentId, commentData }));
        isNewComment && emptyTextArea();
        onCancel();
    };
    const onRegister = () => {
        const editor = document.getElementById(commentId);
        if (editor === null || editor === void 0 ? void 0 : editor.value) {
            if (!isLoggedIn)
                return alert(t('문의는 로그인 후 작성할 수 있어요~'));
            if (defaultValue !== editor.value || secret !== isSecret) {
                const commentData = { is_secret: isSecret, text: editor.value };
                if (isLeader)
                    updateAction(commentData);
                else {
                    confirm({
                        description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [`[${t('새벽 주의')}]`, (0, jsx_runtime_1.jsx)("br", {}), t('문의 등록하면 작가님께 앱 알림 발송돼요.'), (0, jsx_runtime_1.jsx)("br", {}), t('등록하시겠어요?')] })),
                    })
                        .then(() => updateAction(commentData))
                        .catch(() => { });
                }
            }
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({}, props, { children: [(0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { control: (0, jsx_runtime_1.jsx)(Checkbox_1.default, { checked: isSecret, onChange: () => setIsSecret(!isSecret) }), label: t('비밀글') }), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ sx: {
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    color: 'black',
                    bgcolor: 'white !important',
                }, onClick: () => {
                    isNewComment && emptyTextArea();
                    onCancel();
                } }, { children: t('취소') })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ sx: {
                    bgcolor: theme => `${theme.palette.primary.main} !important`,
                    color: 'white',
                }, onClick: onRegister }, { children: isNewComment ? (0, jsx_runtime_1.jsx)("span", { children: t('등록') }) : (0, jsx_runtime_1.jsx)("span", { children: t('수정') }) }))] })));
}) `
  display: grid;
  grid-template-columns: auto 56px 56px;
  column-gap: 8px;
  align-items: center;
  margin-top: -7px;
  button {
    height: 32px;
    border-radius: 4px;
  }
`;
